const PUBLIC_API_PATH = "https://api.demo.celest.rest/api";
const PUBLIC_AUTH_ENDPOINT = "https://apps.demo.celest.rest/auth";
const PUBLIC_APP_BASE = "/";
export {
  PUBLIC_AUTH_ENDPOINT as P,
  PUBLIC_API_PATH as a,
  PUBLIC_APP_BASE as b
};
//# sourceMappingURL=public.js.map
